import React, { useContext, useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ReactImageMagnify from "react-image-magnify";
import DetailInfoElement from "../components/DetailInfoElement";

const DetailProduct = () => {
  let navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [imgArr, setImgArr] = useState([]);
  const [img, setImg] = useState();
  const { contextState, contextFunctions } = useContext(GlobalContext);
  const { setFetchStatus, fetchStatus } = contextState;
  const { handleEditProduct } = contextFunctions;

  const refs = useRef([]);
  const user = JSON.parse(Cookies.get("user"));
  const hoverHandler = (image, i) => {
    setImg(image);
    refs.current[i].classList.add("actived");
    for (var j = 0; j < imgArr.length; j++) {
      if (i !== j) {
        refs.current[j].classList.remove("actived");
      }
    }
  };

  refs.current = [];
  const addRefs = (el) => {
    if (el && !refs.current.includes(el)) {
      refs.current.push(el);
    }
  };

  const handleDetail = (event) => {
    navigate(`/products/edit_product_image/${id}`);
    setFetchStatus(true);
  };

  const handletoviewer = (event) => {
    const id = event.target.value;
    navigate(`/pdfviewer/${id}`);
    setFetchStatus(true);
  };

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const handleDeleteProduct = () => {
    Swal.fire({
      title: `Hapus Produk ${filtered.nama_produk}?`,
      text: `Yakin ingin hapus ${filtered.nama_produk}?`,
      icon: "warning",
      confirmButtonText: "Ya",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://productspec.cyclic.app/product/${id}`)
          .then((response) => {
            setFetchStatus(true);
            swalWithBootstrapButtons.fire(
              "Berhasil!",
              `Berhasil hapus ${filtered.nama_produk}`,
              "success"
            );
            navigate("/products");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        swalWithBootstrapButtons.fire("Batal", "Batal hapus produk", "error");
      }
    });
  };

  const renderText = (str) => {
    if (str === undefined) return;
    else return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };

  // setFetchStatus(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://productspec.cyclic.app/product/${id}`)
      .then((response) => {
        const res = response.data;
        setFiltered(res);
        setImgArr(res.img);
        setImg(res.img[0]);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="loading"></p>;
  }
  return (
    <div className="detail-page">
      <h2 className="text-center fw-bold mb-4">Detail Produk</h2>
      <div className="row">
        <div className="col-lg-6 col-sm-12">
          {img === undefined ? null : (
            <div className="left_2">
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: img,
                    isFluidWidth: true,
                    src: img,
                  },
                  largeImage: {
                    src: img,
                    width: 1500,
                    height: 1500,
                  },
                  enlargedImagePosition: "over",
                }}
              />
            </div>
          )}

          {/* <!-- end of carousel-->? */}
          <div className="left_1 mt-3 mb-4">
            {imgArr.length !== 0 ? (
              imgArr.map((image, i) => (
                <div
                  className={i == 0 ? "img_wrap actived" : "img_wrap"}
                  key={i}
                  onMouseOver={() => hoverHandler(image, i)}
                  onClick={() => hoverHandler(image, i)}
                  ref={addRefs}
                >
                  <img src={image} alt="" />
                </div>
              ))
            ) : (
              <img
                className=""
                alt="-"
                src="https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
              />
            )}
          </div>
        </div>
        <div className=" col-lg-6 col-sm-12">
          <div className=" mb-3 title-buttons">
            <h2 className="fw-bold detail-title">{filtered.nama_produk}</h2>
            <div className="btn-detail-page">
              {user.role === "rnd" && (
                <>
                  <button
                    className="btn btn-primary btn-item-detail"
                    onClick={handleDetail}
                  >
                    Ubah Gambar
                  </button>
                  <button
                    className="btn btn-primary btn-item-detail"
                    onClick={handleEditProduct}
                    value={id}
                  >
                    Edit Data
                  </button>
                  <button
                    className="btn btn-primary btn-item-detail"
                    onClick={handleDeleteProduct}
                  >
                    Hapus
                  </button>
                </>
              )}
              <button
                className="btn btn-primary btn-item-detail"
                onClick={handletoviewer}
                value={id}
              >
                Export PDF
              </button>
            </div>
          </div>

          <span className="kategori py-2 px-4 my-2 text-center rounded-3">
            {renderText(filtered.jenis_produk)}
          </span>
          <ul className="alignMe mt-3">
            <li>
              <span>Dimensi</span> {filtered.dimensi}
            </li>
            <li>
              <span>Bahan</span> {filtered.bahan}
            </li>
            <li>
              <span>Fitur</span> {filtered.fitur}
            </li>
            <li>
              <span>Daya</span> {filtered.daya}
            </li>
          </ul>
          <DetailInfoElement infos={filtered} />
          {/* <GeneratePdf /> */}
        </div>
      </div>
    </div>
  );
};

export default DetailProduct;
